export const MERCHANDISE = 'merchandise'
export const SEEDS = 'seeds'
export const CLONES = 'clones'
export const TINCTURE = 'tincture'
export const OTHER = 'other'
